import React from "react";

function MedicineViewIntro({
  message,
  image,
  visible,
}: {
  message: string;
  image: string;
  visible: boolean;
}) {
  return (
    <article className={`medicine-intro ${visible ? "visible" : ""}`}>
      <div className="content">
        <p>{message}</p>
        <img src={`/assets/${image}`} alt="medicine logo " />
      </div>
      <footer>
        <img src={`/assets/juvederm-white.png`} alt="medicine logo " />
      </footer>
    </article>
  );
}

export default MedicineViewIntro;
